import { render, staticRenderFns } from "./ActiveService.vue?vue&type=template&id=33402451"
import script from "./ActiveService.vue?vue&type=script&lang=js"
export * from "./ActiveService.vue?vue&type=script&lang=js"
import style0 from "./ActiveService.vue?vue&type=style&index=0&id=33402451&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports